import { Variables } from "./Variables";
import triggerIcon from "../../../../new-images/profile/trigger-icon.svg";
import triggerIconSuccess from "../../../../new-images/profile/trigger-icon-success.svg";
import successImg from "../../../../new-images/profile/success.svg";
import ErrorMessage from "../../../errorMessage";
import Input from "../../ui/input/Input";

export const useMiddleNameVariables = (errors, value, setValue) => {

  return new Variables(
    {
      title: "Пожалуйста, укажите ваше",
      bold: " отчество",
      img: triggerIcon,
      prompt:
        "Укажите ваше отчество, чтобы мы могли верифицировать ваши донации.",
      typeImg: "",
      label: "Отчество",
      button: "Сохранить",
      errorMessage: (
        <div>
          <ErrorMessage text={errors} />
        </div>
      ),
      htmlElement: (
        <Input
          placeholder={"Укажите отчество"}
          value={value.label}
          onChange={(e) =>
            setValue({ value: e.target.value, label: e.target.value })
          }
        />
      ),
    },
    {
      title: "Ваше отчество",
      img: triggerIconSuccess,
      label: "Отчество",
      message: "Сохранено",
      succesImg: successImg,
      htmlElement: (
        <Input
          placeholder={"Укажите отчество"}
          defaultValue={value.label}
          disabled={true}
        />
      ),
    }
  )
};
